var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("关于页面")]),_c('p',[_vm._v("这是一个基础的Vue项目框架")]),_c('el-button',{on:{"click":_vm.goBack}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }